<template>
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-menu
                                v-model="modal"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                max-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="displayDate"
                                        label="Data"
                                        prepend-icon="fa fa-calendar"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="date" scrollable @input="closeDatePicker">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                                v-model="icd10"
                                id="icd10"
                                name="icd10"
                                :loading="isLoadingICD"
                                :items="icdList"
                                :search-input.sync="icdKeyword"
                                cache-items
                                flat
                                no-data-text="Nieznaleziono"
                                hide-details
                                item-text="name"
                                item-value="id"
                                prepend-icon="fa-search"
                                label="Wyszukaj w ICD10"
                        >
                            <template v-slot:selection="data">
                                <v-sheet v-html="`${getHtmlDescription(data.item.kod,data.item.opis)}`"></v-sheet>
                            </template>
                            <template v-slot:item="data">
                                <v-sheet v-html="`${getHtmlDescription(data.item.kod,data.item.opis)}`"></v-sheet>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea label="Dodatkowy opis"  v-model="description" name="description" id="description" rows="4"></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="save()" color="success">Zapisz</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {icdService} from "../../services/icdService";
    import swal from "sweetalert";
    import {clientService} from "../../services";
    import * as dayjs from "dayjs";

    export default {
        name: "AddEditAlergy",
        props: ["clientid","editedObject"],
        data() {
          return {
              icd10: 0,
              description: null,
              isLoadingICD: false,
              icdList: [],
              icdKeyword: null,
              title: '',
              modal: false,
              date: new Date().toISOString().substr(0, 10),
              displayDate: new dayjs().format('DD-MM-YYYY')
          }
        },
        mounted() {

        },
        methods: {
            closeForm() {
              this.$emit('close')
            },
            getHtmlDescription(kod,opis) {
                if(kod && opis)
                {
                    return '<span style="font-weight:bold">'+kod+'</span> - ' +opis
                }
                return ''
            },
            getICDValues(val)
            {
                this.isLoadingICD = true
                icdService.getAll({query: val, page: 1, limit:20}).then(data => {
                    data.data.result.items.forEach(item => {

                        if (!this.icdList.find(x => x.id === item.id)) {

                            this.icdList.push({
                                id: item.id,
                                name: item.kod + ' ' +item.opis_icd,
                                kod: item.kod,
                                opis: item.opis_icd
                            });
                        }
                    })
                    this.isLoadingICD = false
                }).catch(() => {
                    this.isLoadingICD = false
                })
            },
            save()
            {
                if(!this.icd10 && !this.description)
                {
                    this.showError(false,'Nie podano kodu ICD ani opisu.')
                    return
                }
                if(this.editedObject && this.editedObject.id > 0)
                {
                    clientService.updateClientDisease({description: this.description, icd10_Id: this.icd10, clientId: this.clientid, recognitionTime: this.date, id: this.editedObject.id}).then(()=> {
                        this.closeForm()
                    }).catch(() => {
                        this.showError(false, 'Błąd zapisu alergii')
                    })

                }
                else
                {
                    clientService.addClientDisease({description: this.description, icd10_Id: this.icd10, type: 1, clientId: this.clientid, recognitionTime: this.date}).then(() => {
                        this.closeForm();
                    }).catch(() => {
                      this.showError(false, 'Błąd dodawania alergii')
                    })
                }
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
            closeDatePicker()
            {
                this.modal = false
                let dj = dayjs(this.date)
                this.displayDate = dj.format("DD-MM-YYYY")
            }
        },
        watch: {
            icdKeyword(val) {
                if(val)
                {
                    this.getICDValues(val)
                }
            },
            editedObject: {
                immediate: true,
                handler(val) {
                    if(val != null)
                    {
                        this.description = val.description
                        let dj = dayjs(val.recognitionTime)
                        this.date = dj.format("YYYY-MM-DD")
                        this.displayDate = dj.format("DD-MM-YYYY")
                        if(val.icd !== null)
                        {

                            this.icdList.push({
                                id: val.icd.id,
                                name: val.icd.kod + ' ' +val.icd.opis_icd,
                                kod: val.icd.kod,
                                opis: val.icd.opis_icd
                            })
                            this.icd10 = val.icd.id
                        }
                        this.title = 'Edytowanie alergii'
                    }
                    else
                    {
                        this.title = 'Dodawanie alergii'
                    }
                }
            }

        }
    }
</script>

<style scoped>

</style>